import styles from "../App.module.css";

export const css = (klasses) => {
  return klasses
    .split(" ")
    .map((cl) => {
      return styles[cl];
    })
    .join(" ");
};

export const errorStyle = (flag) => {
  if (flag) return {};

  return { "border-color": "#ff2222" };
};
